import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";
import { MATHtest } from '../../../../assets/js/fullscreen';
import { RenderMathjax } from '../../../../assets/js/fullscreen';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationAddEditComponent } from '../../notification-management/notification-add-edit/notification-add-edit.component';
@Component({
  selector: 'app-answer-choice-add-edit',
  templateUrl: './answer-choice-add-edit.component.html',
  styleUrls: ['./answer-choice-add-edit.component.css']
})
export class AnswerChoiceAddEditComponent implements OnInit {
  @Input() subjectById:any;
  @Input() Answerflag:any;
  @Input() selectedQuestionById:any;
  @Input() AnswerChoicePopup:boolean;
  @Input() Screenname:any;
  TempAnswerChoice: AnswerChoiceModel;
  InsertAnswerChoice:AnswerChoiceModel;
  AddAnswerChoiceform: FormGroup;
  RTEFlag:string='AnswerChoice';
  Buttonflg:string;
  @Output() ClickAddsolutionHint: EventEmitter<any> = new EventEmitter<any>();
  @Output() EditSolutionHint1: EventEmitter<any> = new EventEmitter<any>();

  @Output() ClickAnswerChoiceNoteBody: EventEmitter<any> = new EventEmitter<any>();
  @Output() EditAnswerChoiceNoteBody: EventEmitter<any> = new EventEmitter<any>();
  @Output() EditAnswerchoiceclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() AddAnswerchoiceclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() AnswerRedirectPreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() RefreshPreviewAnswer: EventEmitter<any> = new EventEmitter<any>();
  @Output() returnfromanswer: EventEmitter<any> = new EventEmitter<any>();
  @Output() Returnpreview: EventEmitter<any> = new EventEmitter<any>();



  constructor(
    public dom:DomSanitizer,
    public service:QuestionManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService,
        private modalService: ModalService,
        private ngModalService: NgbModal
  ) { }

  InitializeForm(){
    this.AddAnswerChoiceform = this.fb.group({
      Answer_Choice_Text:["",VAddAnswerChoice],
    });
  }


  ngOnInit() {
    this.InitializeForm();
    this.getQuestionByID(this.service.QuestionByIDlist[0].Question_ID);
    this.GetAnswerChoiceByQuestionID(this.service.QuestionByIDlist[0].Question_ID);
    if(this.selectedQuestionById.Answer_Choice_ID!=null){
      this.GetAnswerChoiceByID(this.selectedQuestionById.Answer_Choice_ID);
      this.Descriptioncount();
      }
      else{
       this.GetAnswerChoiceByID(null);
       this.Descriptioncount();
      }
      console.log(this.Answerflag);

  }


  async CreateNotification(): Promise<boolean> {
    try {

      const result = await this.modalService.open(
        'Confirmation',
        'Do you want to send notification to all the users about this Question  change?',
        'Yes',
        'No'
      );

      if (!result) {
        return false; // user cancelled
      }

      // Step 2: Open notification modal
      const modalRef = this.ngModalService.open(NotificationAddEditComponent, {
        centered: true,
        size: 'xl',
        windowClass: 'custom-modal-width-notification-question',
        backdropClass: 'custom-backdrop-notification'
      });

      // Pass data into modal
      modalRef.componentInstance.screenName = 'Question';
      modalRef.componentInstance.MaterialId = this.selectedQuestionById.Question_ID;

      // Step 3: Wait for modal close result
      const notificationResult = await modalRef.result
        .then((res: any) => res)
        .catch(() => false);

      return !!notificationResult;
    } catch (error) {
      console.error('CreateNotification dismissed or failed:', error);
      return false;
    }
  }

  AnswerChoiceContent:string
  safehtmlStr:SafeHtml;
  tempsafehtmlStr:SafeHtml;
  GetAnswerChoiceContent(data:any){
    this.AnswerChoiceContent=data;
    //if(this.QuestionBodyContent!=null)
    this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceContent);
    this.tempsafehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceContent);
  }
  AnswerChoiceList:any;
  AnswerChoice:any;
  QuestionBodyget:string;
  arrayIndex:any;
  addanswerchoiceflag:boolean=false;
  AnswerContent:string;
  checkboxvisible:boolean;
  Rightansweravailable:string='Y';
  GetAnswerChoiceByID(data:any){
    this.Rightansweravailable='Y';
    this.service.GetAnserChoiceByID({'AnswerChoiceID':data}).subscribe((i:any)=>{
      this.AnswerChoice=i;
      this.AnswerChoiceList=this.AnswerChoice.AnswerChoiceList;
      this.Validation(this.AnswerChoiceList,null);

      if(this.AnswerChoiceList.length>0){
        if(this.AnswerChoiceList!=null){
         for(let i=0;i<this.AnswerChoiceList.length;i++){
            if(this.AnswerChoiceList[i].ID==0){

              this.arrayIndex=i;
              if(this.AnswerChoiceList[i].Right_Answer_Ind=='Y'){
                this.Answerflag='R'
              }

              this.Validation(this.AnswerChoiceList,i);
            this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceList[i].Answer_Choice_Text);
            //this.tempsafehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceList[i].Answer_Choice_Text);
            //this.AnswerChoiceContent=this.AnswerChoiceList[i].Answer_Choice_Text;
            if(this.AnswerChoiceList[i].Answer_Choice_Text=='<p>All of the Above</p>'){
              this.QuestionBodyget="";
            }
            else if(this.AnswerChoiceList[i].Answer_Choice_Text=='<p>None of the Above</p>'){
              this.QuestionBodyget="";
            }
            else{
            this.QuestionBodyget=this.AnswerChoiceList[i].Answer_Choice_Text;
            }
            this.AnswerContent=this.AnswerChoiceList[i].Answer_Choice_Text;
            this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceList[i].Answer_Choice_Text);
            this.RefreshAnswerpreview(this.safehtmlStr);
            if(this.alertpopupflag){
              this.close();
              this.AddAnswerValidation();
            }
            }

          }



          }
          else{
            for(let i=0;i<this.AnswerChoiceList.length;i++){
              if(this.AnswerChoiceList[i].ID==0){
                this.arrayIndex=i;
                this.Validation(this.AnswerChoiceList,i);
            this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceList[i].Answer_Choice_Text);

            //this.AnswerChoiceContent=this.AnswerChoiceList[i].Answer_Choice_Text;
            if(this.AnswerChoiceList[i].Answer_Choice_Text=='<p>All of the Above</p>'){
              this.QuestionBodyget="";
            }
            else if(this.AnswerChoiceList[i].Answer_Choice_Text=='<p>None of the Above</p>'){
              this.QuestionBodyget="";
            }
            else{
            this.QuestionBodyget=this.AnswerChoiceList[i].Answer_Choice_Text;
            }
            this.AnswerContent=this.AnswerChoiceList[i].Answer_Choice_Text;
            this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceList[i].Answer_Choice_Text);
            this.RefreshAnswerpreview(this.safehtmlStr);
          }
        }
        }

      }
      else{
        // if(this.AnswerChoiceByQuestionid!=null){
        // this.AnswerChoiceByQuestionid.forEach((element: { Right_Answer_Ind: string; }) => {
        //   if(element.Right_Answer_Ind=='Y'){
        //     this.Answerflag='W';
        //     return;
        //   }
        // });

        this.service.GetQuestionByID({'QuestionID':this.service.QuestionByIDlist[0].Question_ID}).subscribe((i:any)=>{
          this.Questionlist=i;
          this.getQuestionByIDlist=this.Questionlist.result;
          this.service.QuestionByIDlist=this.getQuestionByIDlist;
           if(this.service.QuestionByIDlist[0].Right_Answer_Available_Ind=='N'){

          //   this.Answerflag='W';
          // }
          // else{
             this.Rightansweravailable='N';
             if(this.service.ScreenTrackName=='app-question-body-add-edit'){
              this.Buttonflg='QuestionBody';
              this.wronganswercount=0;
              this.AddAnswerValidation();

              }
              if(this.service.ScreenTrackName=='app-question-preview'){
                this.Buttonflg='Redirecttopreview';
                this.wronganswercount=0;
                this.AddAnswerValidation();

                }

          //   this.Answerflag='R';
          }
          else{
            this.Rightansweravailable='Y';
          }
          this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(null);
          this.QuestionBodyget="";


      }, error => {  console.log(error) }
      );

    }






      // this.selectedQuestionList.map((obj) => {
      // obj.checkedflag = false;
      // return obj;
  // })
    // }).catch((e:any)=>{
    //   this.AnswerChoiceList=null;
    // });
  }, error => {  console.log(error) }
  );
  }


  save_submitted:boolean=false;
  AddAnswerChoiceResponse:any;
  index:Number
 // Questionid:string;
  modalclose:any;
  SaveAnswerChoice()
  {
    this.validate1=false;
    //restrict form validation
    if(this.Alltheaboveflag||this.Noneoftheaboveflag){
      this.InsertAnswerChoice=this.AddAnswerChoiceform.value;
      this.InsertAnswerChoice.AllOfTheAboveOrNoneOfTheAboveInd='Y'
      if(this.Alltheaboveflag){
        this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue('<p>All of the Above</p>');
        this.InsertAnswerChoice.Answer_Choice_Text='<p>All of the Above</p>';
      }
      if(this.Noneoftheaboveflag){
        this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue('<p>None of the Above</p>');
        this.InsertAnswerChoice.Answer_Choice_Text='<p>None of the Above</p>';
      }
    }
    else{
      this.InsertAnswerChoice=this.AddAnswerChoiceform.value;
      this.InsertAnswerChoice.AllOfTheAboveOrNoneOfTheAboveInd='N'
    }
    //
    if (this.AddAnswerChoiceform.valid) {
      this.InsertAnswerChoice=this.AddAnswerChoiceform.value;
      this.InsertAnswerChoice.QuestionID=this.selectedQuestionById.Question_ID;
      this.InsertAnswerChoice.Question_Status_ID=this.selectedQuestionById.Question_Status_ID;
      if(this.AnswerChoiceList.length>0){
      if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_ID!=null){
        this.InsertAnswerChoice.AnswerChoiceID=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_ID;
      }
      else{
        this.InsertAnswerChoice.AnswerChoiceID=null;
      }
    }
    else{
      this.InsertAnswerChoice.AnswerChoiceID=null;
    }
      if(this.Answerflag=='R'){
        this.InsertAnswerChoice.RightAnswerInd='Y'
      }
      else{
        this.InsertAnswerChoice.RightAnswerInd='N'
      }
      if(this.Alltheaboveflag||this.Noneoftheaboveflag){
        this.InsertAnswerChoice.AllOfTheAboveOrNoneOfTheAboveInd='Y'
        if(this.Alltheaboveflag){
          this.InsertAnswerChoice.Answer_Choice_Text='<p>All of the Above</p>';
        }
        if(this.Noneoftheaboveflag){
          this.InsertAnswerChoice.Answer_Choice_Text='<p>None of the Above</p>';
        }
      }
      else{
        this.InsertAnswerChoice.AllOfTheAboveOrNoneOfTheAboveInd='N'
      }

      this.service.CreateOrModifyAnswerChoice(this.InsertAnswerChoice).subscribe(async (i:any)=>{
        this.AddAnswerChoiceResponse=i;
        if(this.AddAnswerChoiceResponse.Message=="Success")
        {
            this.toastr.success('Saved Successfully', 'Success',{timeOut: 500});
            this.save_submitted=false;
            this.CreateNotification()
            this.Cancel()
            // if(this.selectedQuestionById.Right_Answer_Ind=='Y')
            // {
            //   this.Answerflag='R'
            // };
            // if(this.selectedQuestionById.Answer_Choice_ID!=null){
            //   this.GetAnswerChoiceByID(this.selectedQuestionById.Answer_Choice_ID);
            //   this.Descriptioncount();
            //   }
            //   else{
                this.selectedQuestionById.Answer_Choice_ID=this.AddAnswerChoiceResponse.Answer_Choice_ID;
               this.GetAnswerChoiceByID(this.AddAnswerChoiceResponse.Answer_Choice_ID);
               this.Descriptioncount();
              //}
              console.log(this.Answerflag);
              this.GetAnswerChoiceByQuestionID(this.selectedQuestionById.Question_ID);
              this.getQuestionByID(this.selectedQuestionById.Question_ID);
            // console.log(this.EditQuestionBodyPopup,'EditQuestionBodyPopup');
            // if(this.AnswerChoicePopup){
            //   this.AddAnswerchoiceclose.emit(this.modalclose);
            // }
            // else{
            //   this.EditAnswerchoiceclose.emit(this.modalclose);
            // }

        }
        else{
          this.toastr.error(this.AddAnswerChoiceResponse.Message);
        }
}, error => {
  this.AddAnswerChoiceResponse=error;
     this.toastr.error(this.AddAnswerChoiceResponse.Message);
     this.save_submitted=false;
    console.log(error) }
);
    }
  }
  validate1:boolean;
  GetLatexBodyContentchanges(data:boolean){

    this.validate1=data;
    console.log(this.validate1,'this.validate1')
  }






  Descriptionvaluelength:any;
 DescriptionMaxlength:any;
 Descriptioncount(){
  this.DescriptionMaxlength=2000;
  if(this.AddAnswerChoiceform.controls.Answer_Choice_Text.value!=''&&this.AddAnswerChoiceform.controls.Answer_Choice_Text.value!=null){
    if(this.AddAnswerChoiceform.controls.Answer_Choice_Text.value.length>0){
        this.Descriptionvaluelength =this.AddAnswerChoiceform.controls.Answer_Choice_Text.value.length;
    }
    else{
      this.Descriptionvaluelength=0;
    }
  }
  else{
    this.Descriptionvaluelength=0;

  }
 }


  QuestionBodyModalPopup:boolean
  AnswerChoiceNoteBody(){
    this.service.ScreenTrackName='app-answer-choice-add-edit';
    this.Buttonflg='AnswerChoiceNoteBody';
    // if(this.QuestionBodyget==this.AnswerChoiceContent){
     if(!this.validate1){
      if(this.AnswerChoicePopup){
        this.ClickAnswerChoiceNoteBody.emit(this.selectedQuestionById);
        }
        else{
          this.EditAnswerChoiceNoteBody.emit(this.selectedQuestionById);
        }
  }
  else{
    this.Alertpopup();
  }


  }

  AddSolutionHint(){
    this.service.ScreenTrackName='app-answer-choice-add-edit';
    this.Buttonflg='AddSolutionHint';
    // if(this.QuestionBodyget==this.AnswerChoiceContent){
    if(!this.validate1){
      if(this.AnswerChoicePopup){
        this.ClickAddsolutionHint.emit(this.selectedQuestionById);
        }
        else{
          this.EditSolutionHint1.emit(this.selectedQuestionById);
        }
  }
  else{
    this.Alertpopup();
  }


  }

  Previousflag:boolean=false;
  Nextflag:boolean=false;
  alltheaboveviewflag:boolean;
  alltheabovecount:number=0;
  mainindex:number=0;
  Validation(data:any,index:any){
    this.alltheabovecount=0;
     if(data.length<=1){
       this.Previousflag=true;
       this.Nextflag=true;
     }
     else if((index==data.length-1))
     {
      this.Previousflag=false;
      this.Nextflag=true;
     }
     else if((index==data.length-1))
     {
      this.Previousflag=true;
      this.Nextflag=false;
     }
     else if(index==0)
     {
      this.Previousflag=true;
      this.Nextflag=false;
     }
     else{
      this.Previousflag=false;
       this.Nextflag=false;
     }


     //alltheabvevalidation
     if(index!=null){
     for(var j=0;j<data.length;j++){
      if(data[j].All_Of_The_Above_Or_None_Of_The_Above_Ind=='N'){
        this.alltheabovecount++;
      }

     }
     if(this.alltheabovecount==data.length){
      if((data[index].Answer_Choice_Text=='')){
      this.alltheaboveviewflag=true;
      this.Alltheaboveflag=false;
      this.Noneoftheaboveflag=false;
      if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
        this.ALLAboveNoneAboveChoiceflag=false;
        }
      }
      else{
        this.alltheaboveviewflag=false;
        this.Alltheaboveflag=false;
        this.Noneoftheaboveflag=false;
        if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
          this.ALLAboveNoneAboveChoiceflag=false;
          }
      }
     }
     else if(data[index].All_Of_The_Above_Or_None_Of_The_Above_Ind=='Y'){
      this.alltheaboveviewflag=true;
      if(data[index].Answer_Choice_Text=='<p>All of the Above</p>')
      {
        this.Alltheaboveflag=true;
        this.ALLAboveNoneAboveChoiceflag=true;
        //this.QuestionBodyget=data[index].Answer_Choice_Text;
      }
      else if(data[index].Answer_Choice_Text=='<p>None of the Above</p>'){
         this.Noneoftheaboveflag=true;
         this.ALLAboveNoneAboveChoiceflag=true;
         //this.QuestionBodyget=data[index].Answer_Choice_Text;
      }
      else{
        this.Alltheaboveflag=false;
        this.Noneoftheaboveflag=false;
        if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
          this.ALLAboveNoneAboveChoiceflag=false;
          }
      }
     }
     else{
      this.alltheaboveviewflag=false;
      this.Alltheaboveflag=false;
      this.Noneoftheaboveflag=false;
      if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
        this.ALLAboveNoneAboveChoiceflag=false;
        }
     }
   }
    else{

      if(this.service.QuestionByIDlist[0].All_Of_The_Above_Or_None_Of_The_Above_Ind!='Y'){


            this.alltheaboveviewflag=true;
            this.Alltheaboveflag=false;
            this.Noneoftheaboveflag=false;
            if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
            this.ALLAboveNoneAboveChoiceflag=false;
            }

      }
      else if(this.service.QuestionByIDlist[0].All_Of_The_Above_Or_None_Of_The_Above_Ind=='Y'&&data.length==0){
        this.alltheaboveviewflag=false;
          this.Alltheaboveflag=false;
          this.Noneoftheaboveflag=false;
          if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
          this.ALLAboveNoneAboveChoiceflag=false;
          }
      }

     }



  }

  PreviousflagButton(){
    this.Buttonflg='PreviousflagButton';
    this.GetAnswerChoiceByQuestionID(this.selectedQuestionById.Question_ID);

    // if(this.QuestionBodyget==this.AnswerChoiceContent){
     if(!this.validate1){
      this.arrayIndex=this.arrayIndex-1;
      this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);

      //this.AnswerChoiceContent=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text
      if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>All of the Above</p>'){
        this.QuestionBodyget="";
      }
      else if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>None of the Above</p>'){
        this.QuestionBodyget="";
      }
      else{
      this.QuestionBodyget=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
      }
      //this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);
      if(this.AnswerChoiceList[this.arrayIndex].Right_Answer_Ind=='Y'){
        this.Answerflag='R';
      }
      else{
        this.Answerflag='W';
      }
      this.Validation(this.AnswerChoiceList,this.arrayIndex);
  }
  else{
    this.Alertpopup();
  }



  }

  NextButton(){
    this.Buttonflg='NextButton';
    this.GetAnswerChoiceByQuestionID(this.selectedQuestionById.Question_ID);
    // if(this.QuestionBodyget==this.AnswerChoiceContent){
     if(!this.validate1){
      this.arrayIndex=this.arrayIndex+1;
    this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);

    //this.AnswerChoiceContent=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
    if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>All of the Above</p>'){
      this.QuestionBodyget="";
    }
    else if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>None of the Above</p>'){
      this.QuestionBodyget="";
    }
    else{
    this.QuestionBodyget=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
    }
    //this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);
    if(this.AnswerChoiceList[this.arrayIndex].Right_Answer_Ind=='Y'){
      this.Answerflag='R';
    }
    else{
      this.Answerflag='W';
    }
    this.Validation(this.AnswerChoiceList,this.arrayIndex);
  }
  else{
    this.Alertpopup();
  }


  }

  wronganswercount:number=0;

  AddAnswerChoice(){
    this.service.ScreenTrackName='app-answer-choice-add-edit';
    this.Buttonflg='AddAnswerChoice';
    this.wronganswercount=0;
    this.Rightansweravailable='Y';

    // if(this.QuestionBodyget==this.AnswerChoiceContent){
     if(!this.validate1){
      //this.GetAnswerChoiceByID(null);
      this.AddAnswerValidation();
  }
  else{
    this.Alertpopup();
  }


  }
  rightansweralertflag:boolean=false;
  rightAnsweralert(){
    this.rightansweralertflag=!this.rightansweralertflag;
  }
  Wrongansweralertflag:boolean=false;
  Wrongansweralert(){
    this.Wrongansweralertflag=!this.Wrongansweralertflag;
  }

  AddAnswerValidation(){
    this.service.GetQuestionByID({'QuestionID':this.service.QuestionByIDlist[0].Question_ID}).subscribe((i:any)=>{
      this.Questionlist=i;
      this.getQuestionByIDlist=this.Questionlist.result;
      this.service.QuestionByIDlist=this.getQuestionByIDlist;
      if(this.service.QuestionByIDlist[0].Right_Answer_Available_Ind=='N'){
    for(let i=0;i<this.AnswerChoiceByQuestionid.length;i++){
      if(this.AnswerChoiceByQuestionid[i].Right_Answer_Ind=='N'){
        this.wronganswercount++;
      }

    }
    if(this.wronganswercount==7){
       this.Wrongansweralert();
    }
    else{
      this.rightAnsweralert();
    }

    this.Rightansweravailable='N'
  }
  else{
    this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(null);
    this.QuestionBodyget="";
     this.Answerflag='W'
     this.Rightansweravailable='Y';
     this.GetAnswerChoiceByID(null);
  }
}, error => {  console.log(error) }
);
  }
  saverightanswer(){
    this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(null);
    this.QuestionBodyget="";
    this.Answerflag='R'
    this.Validation(0,null);
    if(this.rightansweralertflag){
       this.rightAnsweralert();
    }
    if(this.service.ScreenTrackName!='app-question-body-add-edit'&&this.service.ScreenTrackName!='app-question-preview'){
    this.GetAnswerChoiceByID(null);
    }
  }
  savewronganswer(){
    this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(null);
    this.QuestionBodyget="";
    this.Answerflag='W'
    this.Validation(0,null);
    if(this.rightansweralertflag){
       this.rightAnsweralert();
    }
    if(this.service.ScreenTrackName!='app-question-body-add-edit'&&this.service.ScreenTrackName!='app-question-preview'){
    this.GetAnswerChoiceByID(null);
    }
  }
  saverightanswerinwrong(){
    this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(null);
    this.QuestionBodyget="";
    this.Answerflag='R'
    this.Validation(0,null);
    this.GetAnswerChoiceByID(null);
    if(this.Wrongansweralertflag){
       this.Wrongansweralert();
    }
  }
  AnswerChoiceByQuestionid:any;
  response:any;
  GetAnswerChoiceByQuestionID(data:any){

    this.service.GetAnswerChoiceByQuestionID({'QuestionID':data}).subscribe((i:any)=>{
      this.response=i;
      this.AnswerChoiceByQuestionid=this.response.SubjectExistsInd;
      if(this.AnswerChoiceByQuestionid.length>7){
        this.addanswerchoiceflag=true;
      }
      else{
        this.addanswerchoiceflag=false;
      }


    }, error => {  console.log(error) }
    );
    }

    validate:boolean=false;
    latexeditlist: any[]= [];
  GetLatexBodyContent(data:any)
 {


    // this.latexeditlist.push({latextext:data.latex,equation:data.mathjax,cursor:data.cursor});
    // console.log(this.latexeditlist,'latexeditlist')
    this.latexeditlist=data;
console.log(this.latexeditlist,'latexeditlist')

 }

 Indicator:boolean=false;
 RemoveLatexBodyContent(data:any){
  console.log(data,'removecursor');
  for(var j=0;j<this.latexeditlist.length;j++){
    console.log(data,j,this.latexeditlist[j].cursor);
    if(this.latexeditlist[j].cursor==data){
      //this.Indicator=true;
      this.latexeditlist.splice(j,1);
      break;
      //this.Indicator=true;
      //break;
    }
    // if(this.Indicator)
    // {
    // this.latexeditlist[j].cursor=this.latexeditlist[j].cursor-1;
    // }
  }

 }

 Editlatex(data:any,index:any){
    console.log(data,'Editlatex')
    let rendermathjax=RenderMathjax(data)
    console.log(rendermathjax,'mathjax')
    this.latexeditlist[index].latex=data;
    this.latexeditlist[index].mathjax=rendermathjax;
 }

 copyInput(index:any){
  this.copyMessage(this.latexeditlist[index].latex);
 }


  copyMessage(val: string){
    document.body.oncopy = function() { return true; }
    const selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  //document.body.oncopy = function() { return false; }

 }


 alertpopupflag:boolean;
 Alertpopup(){
  this.alertpopupflag=!this.alertpopupflag
 }

 Savecontent(){
  // if(this.alertpopupflag){
  //   this.Alertpopup();
  // }
  this.validate1=false;
   this.SaveAnswerChoice();
 }

 close(){
  if(this.alertpopupflag){
    this.Alertpopup();
  }
  this.validate1=false;
  this.RefreshAnswerpreview(this.safehtmlStr);
  // if(this.Screenname=='QuestionBody'){
  //    this.Buttonflg='QuestionBody';
  // }

 if(this.Buttonflg=='QuestionBody'||this.Buttonflg=='Cancel'||this.Buttonflg=='Redirecttopreview'){
  if(this.service.ScreenTrackName=='app-question-body-add-edit'){
    this.Buttonflg='QuestionBody';
  }
  if(this.service.ScreenTrackName=='app-question-add-edit'){
    this.Buttonflg='Cancel';
  }
  if(this.service.ScreenTrackName=='app-question-preview'){
    this.Buttonflg='Redirecttopreview';
  }
}




  if(this.Buttonflg=='AnswerChoiceNoteBody'){

    if(this.AnswerChoicePopup){
      this.ClickAnswerChoiceNoteBody.emit(this.selectedQuestionById);
      }
      else{
        this.EditAnswerChoiceNoteBody.emit(this.selectedQuestionById);
      }
  }
  if(this.Buttonflg=='AddSolutionHint'){
    if(this.AnswerChoicePopup){
      this.ClickAddsolutionHint.emit(this.selectedQuestionById);
      }
      else{
        this.EditSolutionHint1.emit(this.selectedQuestionById);
      }
  }
  if(this.Buttonflg=='PreviousflagButton'){
    this.arrayIndex=this.arrayIndex-1;
      this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);

      //this.AnswerChoiceContent=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
      if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>All of the Above</p>'){
        this.QuestionBodyget="";
      }
      else if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>None of the Above</p>'){
        this.QuestionBodyget="";
      }
      else{
      this.QuestionBodyget=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
      }
      //this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);
      if(this.AnswerChoiceList[this.arrayIndex].Right_Answer_Ind=='Y'){
        this.Answerflag='R';
      }
      else{
        this.Answerflag='W';
      }
      this.Validation(this.AnswerChoiceList,this.arrayIndex);
  }
  if(this.Buttonflg=='NextButton'){
    this.arrayIndex=this.arrayIndex+1;
    this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);
    this.AnswerChoiceContent=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
    if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>All of the Above</p>'){
      this.QuestionBodyget="";
    }
    else if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>None of the Above</p>'){
      this.QuestionBodyget="";
    }
    else{
    this.QuestionBodyget=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
    }
    //this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);
    if(this.AnswerChoiceList[this.arrayIndex].Right_Answer_Ind=='Y'){
      this.Answerflag='R';
    }
    else{
      this.Answerflag='W';
    }
    this.Validation(this.AnswerChoiceList,this.arrayIndex);
  }
  if(this.Buttonflg=='AddAnswerChoice'){

    //this.GetAnswerChoiceByID(null);
  }
  if(this.Buttonflg=='QuestionBody'){
      if(this.AnswerChoicePopup){
        this.returnfromanswer.emit(this.service.QuestionByIDlist);
      }
      else{
        this.returnfromanswer.emit(this.service.QuestionByIDlist);
      }


  }
  if(this.Buttonflg=='Cancel'){
    if(this.AnswerChoicePopup){
      this.AddAnswerchoiceclose.emit(this.modalclose);
    }
    else{
      this.EditAnswerchoiceclose.emit(this.modalclose);
    }
  }
  if(this.Buttonflg=='Redirecttopreview')
  {
    //if(this.QuestionBodyPopup){
     this.Returnpreview.emit(this.modalclose);
    //}
  }




 }
 Cancel(){
  this.Buttonflg='Cancel';

  if(this.service.ScreenTrackName=='app-question-body-add-edit'){
    this.Buttonflg='QuestionBody';
  }
  if(this.service.ScreenTrackName=='app-question-add-edit'){
    this.Buttonflg='Cancel';
  }
  if(this.service.ScreenTrackName=='app-question-preview'){
    this.Buttonflg='Redirecttopreview';
  }
  // let quillcurrent=extractContent(this.QuestionBodyContent);
// let quill=extractContent(this.selectedQuestionById[0].Question_Text);
//   let parser = new DOMParser();
//   const doc1 = parser.parseFromString(this.QuestionBodyContent, 'text/html');

//  const doc2 = parser.parseFromString(this.selectedQuestionById[0].Question_Text, 'text/html');
// if(this.QuestionBodyget==this.AnswerChoiceContent){
  if(this.Buttonflg=='Cancel'){
   if(!this.validate1){
    if(this.AnswerChoicePopup){
      this.AddAnswerchoiceclose.emit(this.modalclose);
    }
    else{
      this.EditAnswerchoiceclose.emit(this.modalclose);
    }
  }
  else{
    this.Alertpopup();
  }
}
  if(this.Buttonflg=='QuestionBody')
  {
    if(!this.validate1){
      if(this.AnswerChoicePopup){
        this.returnfromanswer.emit(this.service.QuestionByIDlist);
      }
      else{
        this.returnfromanswer.emit(this.service.QuestionByIDlist);
      }
    }
    else{
      this.Alertpopup();
    }
  }
  if(this.Buttonflg=='Redirecttopreview')
  {
    if(!this.validate1){

       this.Returnpreview.emit(this.modalclose);

    }
    else{
      this.Alertpopup();
    }
  }
}




 ///Edit latex

 editlatexbutton:boolean;
 getlatex:string;
 currentindex:number;
 Editlatexbutton(index:any){
  this.currentindex=index;
  this.Editlatexpopup();
  this.getlatex=this.latexeditlist[index].latex;

 }
 Editlatexpopup(){
  this.editlatexbutton=!this.editlatexbutton;
 }

 closelatexpopup(){

  if(this.latexeditlist[this.currentindex].latex==this.getlatex){
    if(this.editlatexbutton)
    {
      this.Editlatexpopup();
    }
  }
  else{
    this.latexAlertpopup();
  }



 }

 Savelatex(){
  this.latexeditlist[this.currentindex].latex=this.getlatex;
  this.Editlatex(this.getlatex,this.currentindex);
  this.copyMessage(this.getlatex);
  if(this.editlatexbutton){
    this.Editlatexpopup();
  }
 }
 LatexpopupCancel(){
  if(this.latexeditlist[this.currentindex].latex==this.getlatex){
    if(this.editlatexbutton){
      this.Editlatexpopup();
    }
  }
  else{
    this.latexAlertpopup();
  }

 }

 latexalert:boolean;
 latexAlertpopup(){
   this.latexalert=!this.latexalert;
 }

 Savelatexcontent(){
  this.latexAlertpopup();
  this.Savelatex();
 }
 closelatex(){
  this.latexAlertpopup();
  this.Editlatexpopup();
 }
HTML:SafeHtml;

 AnswerRedirecttoPreview(){
  this.service.ScreenTrackName='app-answer-choice-add-edit';
  if(this.Alltheaboveflag){
    this.tempsafehtmlStr=this.dom.bypassSecurityTrustHtml('<p>All of the Above</p>');
  }
  else if(this.Noneoftheaboveflag){
    this.tempsafehtmlStr=this.dom.bypassSecurityTrustHtml('<p>None of the Above</p>');
  }

  let list={
    safehtmlStr:this.tempsafehtmlStr,
    Screename:'AnswerChoice',
    Indicator:this.arrayIndex
  }
   this.AnswerRedirectPreview.emit(list);

 }
 RefreshAnswerpreview(data:SafeHtml){
  let list={
    safehtmlStr:data,
    Screename:'AnswerChoice',
    Indicator:this.arrayIndex
  }
   this.RefreshPreviewAnswer.emit(list);
 }

 //checkboxs
 Alltheaboveflag:boolean=false;
 Noneoftheaboveflag:boolean=false;
 ALLAboveNoneAboveChoiceflag:boolean=false;
 checkboxdirty:boolean=false;
 Alltheabove(){
  this.checkboxdirty=true;
   this.Alltheaboveflag=!this.Alltheaboveflag;
   if(this.Noneoftheaboveflag){
    this.Noneoftheaboveflag=false;
   }
   if(this.Alltheaboveflag){
    this.ALLAboveNoneAboveChoiceflag=true;
   }
   if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
    this.ALLAboveNoneAboveChoiceflag=false;
   }
 }

 Noneoftheabove(){
  this.checkboxdirty=true;
  this.Noneoftheaboveflag=!this.Noneoftheaboveflag;
  if(this.Alltheaboveflag){
    this.Alltheaboveflag=false;
  }
  if(this.Noneoftheaboveflag){
    this.ALLAboveNoneAboveChoiceflag=true;
   }
   if(!this.Alltheaboveflag&&!this.Noneoftheaboveflag){
    this.ALLAboveNoneAboveChoiceflag=false;
   }
 }

 Questionlist:any;
 getQuestionByIDlist:any;
 getQuestionByID(data:any)
  {
    this.service.GetQuestionByID({'QuestionID':data}).subscribe((i:any)=>{
      this.Questionlist=i;
      this.getQuestionByIDlist=this.Questionlist.result;
      this.service.QuestionByIDlist=this.getQuestionByIDlist;






  }, error => {  console.log(error) }
  );

  }

  Answerdetails:any
  DeleteAnswerChoice(data:any){
    // for (let item of this.AnswerChoiceByQuestionid) {
    //   if(item.Answer_Choice_ID==this.AnswerChoiceList[this.arrayIndex].Answer_Choice_ID){
    //     this.Answerdetails=item;
    //     this.AnswerChoiceList.splice(0,this.arrayIndex)

    //     break;
    //   }
    // }


    this.DeleteAnswerchoicepopup();
  }

  deletealertpopup:boolean
  DeleteAnswerchoicepopup(){
  this.deletealertpopup=!this.deletealertpopup;
  }

  replacedeletebutton(){
    for(var i=0;i<this.AnswerChoiceByQuestionid.length;i++){
      if(this.AnswerChoiceByQuestionid[i].Answer_Choice_ID==this.AnswerChoiceList[this.arrayIndex].Answer_Choice_ID){
        this.Answerdetails=this.AnswerChoiceByQuestionid[i];
        this.AnswerChoiceList.splice(this.arrayIndex,1);
        if(this.AnswerChoiceList.length>0){
        this.arrayIndex=this.AnswerChoiceList.length-1;
        }
        else{
          this.arrayIndex=null;
        }
        break;
      }
    }
   this.DeleteAnswerChoiceValue();
   }

   CloseDeleteAlertpopup(){
     this.DeleteAnswerchoicepopup();
   }


  AddAnswerChoiceResponse1:any;
  test:string;
  DeleteAnswerChoiceValue()
  {
    this.InsertAnswerChoice = this.AddAnswerChoiceform.value;
    this.InsertAnswerChoice.QuestionID=this.Answerdetails.Question_ID;
    this.InsertAnswerChoice.Question_Status_ID=this.Answerdetails.Question_Status_ID;
    this.InsertAnswerChoice.AnswerChoiceID=this.Answerdetails.Answer_Choice_ID;

 this.service.DeleteAnswerChoice(this.InsertAnswerChoice).subscribe((i:any)=>{
 this.AddAnswerChoiceResponse1=i;
        if(this.AddAnswerChoiceResponse1.Message=="Success")
        {
            this.toastr.success("Answer Choice Deleted Successfully");
            // this.RightAnswer1=null;
            // this.WrongAnswer1=null;
            // this.WrongAnswer2=null;
            // this.WrongAnswer3=null;
            // this.WrongAnswer4=null;
            // this.WrongAnswer5=null;
            // this.WrongAnswer6=null;
            // this.WrongAnswer7=null;
            // this.RightAnswer11=this.test;
            // this.WrongAnswer11=this.test;
            // this.WrongAnswer22=this.test;
            // this.WrongAnswer33=this.test;
            // this.WrongAnswer44=this.test;
            // this.WrongAnswer55=this.test;
            // this.WrongAnswer66=this.test;
            // this.WrongAnswer77=this.test;
            this.DeleteAnswerchoicepopup();

            this.GetAnswerChoiceByQuestionID(this.selectedQuestionById.Question_ID);
            if(this.AnswerChoiceList.length>0){
            this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text);
            this.AnswerChoiceContent=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
            if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>All of the Above</p>'){
              this.QuestionBodyget="";
            }
            else if(this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text=='<p>None of the Above</p>'){
              this.QuestionBodyget="";
            }
            else{
            this.QuestionBodyget=this.AnswerChoiceList[this.arrayIndex].Answer_Choice_Text;
            }

            if(this.AnswerChoiceList[this.arrayIndex].Right_Answer_Ind=='Y'){
              this.Answerflag='R';
            }
            else{
              this.Answerflag='W';
            }
            this.Validation(this.AnswerChoiceList,this.arrayIndex);
          }
          else{
            this.AddAnswerChoiceform.controls['Answer_Choice_Text'].setValue(null);
          this.QuestionBodyget="";
            this.Validation(this.AnswerChoiceList,null);
          }




        }
        else{
          this.toastr.error(this.AddAnswerChoiceResponse1.Message);
        }


}, error => {
  this.AddAnswerChoiceResponse=error;
     this.toastr.error(this.AddAnswerChoiceResponse.statusText);
     this.save_submitted=false;
    console.log(error) }
);
    }







}
